module.exports = __webpack_public_path__ + "img/next_button@2x.e053aabd.png";